<template>
  <div class="selection">
    <ObSelection
      v-model="sortType"
      :options="options"
      :showOverlay="true"
      @select="switchType"
    />
  </div>
  <ObList
    ref="obListRef"
    :load="getMyCircleList"
  >
    <component 
      v-for="(item, index) in list"
      :key="item.id"
      :is="item.components" 
      :cardInfo="item"
      :showTag="!!item?.circleInfo?.id"
      :index="index"
      :showStick="Boolean(item.stick)"
    />
  </ObList>
</template>

<script setup>

const { proxy } = getCurrentInstance()

const obListRef = ref(null)

const sortType = ref(1)

const list = ref([])

const options = ref([{
  label: proxy.$t('latestCreated'),
  value: 1
}, {
  label: proxy.$t('latestActivity'),
  value: 2
}])

function switchType () {
  list.value = []
  obListRef.value.onRefresh()
}

async function getMyCircleList (params) {
  const apiName = sortType.value === 1 ? 'getMyCircleList' : 'getMyCircleListRecent'
  const { pageData = {
    page: 1,
    limit: 20
  } } = params || {}
  const { code, data, msg} = await proxy.$http[apiName]({
    ...pageData,
    type: sortType.value
  })
  let finished = false
  if (code === 200 && data) {
    const { rows, total } = data || {}
    for(const i of rows) {
      switch (i.type) {
        case 1:
          i.components = markRaw(defineAsyncComponent(() => import('@/components/card/articleCard.vue')))
          break
        case 2:
          i.components = markRaw(defineAsyncComponent(() => import('@/components/card/momentCard.vue')))
          break
        case 4:
          i.components = markRaw(defineAsyncComponent(() => import('@/components/card/pollCard.vue')))
          break
        default:
      }
    }
    list.value = [...list.value, ...rows]
    finished = list.value.length >= total || !rows?.length
  }
  return {
    code,
    finished
  }
}

</script>

<style lang="postcss" scoped>
.selection {
  margin-top: 12px;
}
</style>